import React, { FC, useCallback, useEffect } from 'react'
import { Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { FormProvider, useForm } from 'react-hook-form'
import { UpdateCommissionFeeRequestDto } from '@sparling/financial-common/dist'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { Modal } from '../../../components/Modal'
import { InputField } from '../../../components/InputField'
import { canUpdateUserData, updateUserCommissionFeeRequest } from '../../../store/actions'
import { canUpdateUserDataSelector } from '../../../store/selectors'

interface ClientTypeCreateModalProps {
  isOpen: boolean
  modalClose: () => void
  idSf: string | undefined
  refresh: () => void
  defaultValue: number | undefined
}

export const CommissionFeeUpdateModal: FC<ClientTypeCreateModalProps> = ({
  isOpen,
  modalClose,
  idSf,
  defaultValue,
  refresh,
}) => {
  const dispatch = useDispatch()
  const canUpdate = useSelector(canUpdateUserDataSelector)

  const formMethods = useForm<UpdateCommissionFeeRequestDto>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(UpdateCommissionFeeRequestDto),
  })

  const {
    handleSubmit,
    formState: { isValid },
    reset,
  } = formMethods

  const onSubmit = useCallback(
    (data) => {
      if (idSf) {
        dispatch(updateUserCommissionFeeRequest({ idSf, ...data }))
        reset()
      }
    },
    [idSf, dispatch, reset],
  )

  useEffect(() => {
    if (canUpdate) {
      dispatch(canUpdateUserData(false))
      refresh()
      modalClose()
    }
  }, [canUpdate, dispatch, refresh, modalClose])

  return (
    <Modal
      title={'Update Commission Rate'}
      submitTitle="Update"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
      isWidthAuto
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <InputField
              inputName={'commissionFee'}
              inputType={'text'}
              labelName={'Commission Rate'}
              fullWidth
              defaultValue={defaultValue}
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
